import React from 'react';
import { Box, Icon, Typography } from 'bonfire-kindling';

const ErrorMessage = ({ message }) => (
  <Box mx="14px" mt="4px" display="flex" alignItems="flex-end">
    <Box marginRight="0.5rem" display="inline" alignItems="flex-end">
      <Icon iconName="exclamation-triangle" color="error" size="large" />
    </Box>
    <Typography color="error" variant="caption" display="inline">
      <em>{message}</em>
    </Typography>
  </Box>
);

export default ErrorMessage;
